<template>
    <div class="o-sms-modal-ready-header-invalid sms-modal-ready-header-invalid">
        <svg-icon
            original
            name="icons/warning"
            class="o-sms-modal-ready-header-invalid__icon"
        />
        <span class="sms-modal-ready-header-invalid__text">
            {{ value }}
        </span>
        <span 
            class="sms-modal-ready-header-invalid__text sms-modal-ready-header-invalid__text--highlight"
            v-html="$t('o-sms-modal-ready-header-invalid_text')"
        />
        <span class="sms-modal-ready-header-invalid__text">
            {{ $t('o-sms-modal-ready-header-invalid_tip') }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'OSmsModalReadyHeaderInvalid',
    props: {
        value: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss">
@import "o-sms-modal-ready-header-invalid";   
</style>